module.exports = __webpack_public_path__ + "static/delivery-73b085500ee3862aac58ca2624e1af43.png";